import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import "./NotoficationInfo.css";
import { useNavigate } from "react-router-dom";
import { NotificationInfoType } from "./interfaces";
export const NotificationInfo = ({ type, setIsNotificationInfo, }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const hideNotificationInfo = () => {
        localStorage.setItem("notificationInfoClosed", "true");
        setIsNotificationInfo(false);
    };
    const closeNotificationInfo = () => {
        hideNotificationInfo();
        navigate("/control-guide");
    };
    return (_jsxs("div", { className: "notification-info-wrapper", children: [_jsx("button", { className: "close-btn", "aria-label": "Close", onClick: () => hideNotificationInfo(), children: "\u00D7" }), _jsx("div", { className: "title", children: t(`notificationInfo.${type}`) }), _jsx("p", { children: t("notificationInfo.text") }), NotificationInfoType.Update === "update" && (_jsx("button", { className: "btn", onClick: () => closeNotificationInfo(), children: t("notificationInfo.btnInfo") }))] }));
};
